import { MessageService } from 'primeng/api';
import { Component, Inject } from '@angular/core';
import { MerchantService } from 'app/services';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MerchantUserAndMerchantForConfirmedResponseDto } from '../company-details/merchant-user-and-merchant-for-confirmed-response-dto';
import { MerchantStatusEnum } from 'app/models';
import { MerchantStoreStatusRequestDto as MerchantStatusRequestDto } from '../../../../models/lokal/merchant-status-request';

@Component({
  selector: 'message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  providers: [MessageService],
})
export class MessageDialogComponent {
  loading = false;
  constructor(
    private merchantService: MerchantService,
    private messageService: MessageService,
    @Inject(MAT_DIALOG_DATA)
    public merchantUser: MerchantUserAndMerchantForConfirmedResponseDto
  ) {}

  launchMyStore() {
    this.loading = true;
    const merchantStatusPayload: MerchantStatusRequestDto = {
      MerchantId: this.merchantUser.MerchantId,
      StatusId: MerchantStatusEnum.StoreCreation,
    };

    this.merchantService
      .merchantStatusChange(merchantStatusPayload, this.messageService)
      .then((response) => {
        location.reload();
        this.loading = false;
      });
  }
}
